import React from "react";
import PropTypes from "prop-types";
import ModalCustom from "./ModalCustom";

const DeleteUserConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  loading = false
}) => {
  return (
    <ModalCustom show={show} onHide={onHide} size="lg">
      <div className="p-4">
        <div className="d-flex align-items-center justify-content-center mb-3 gap-3">
            <i className="fa fa-exclamation-triangle text-warning fa-2x" aria-hidden="true"></i>
            <h4 className="mb-0 fw-medium fs-3 ">Confirm User Deletion</h4>
            <i className="fa fa-exclamation-triangle text-warning fa-2x" aria-hidden="true"></i>
        </div>

        <div className="mb-1 fs-5 fw-light">
          <p className="mb-2 fs-5 fw-light">
            You are about to permanently delete this user account.
          </p>

          <div className="mb-1">
            <ul>
              <li>
                This action cannot be undone.
              </li>
              <li>
                All historical records tied to this user will be lost.
              </li>
              <li>
                For auditing and compliance purposes, we strongly recommend disabling the account instead of deleting it.
              </li>
            </ul>
          </div>

          <p className="mb-3 fs-5 fw-light">
            Are you absolutely sure you want to proceed with deletion?
          </p>
        </div>

        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-primary btn-sm rounded-pill px-4 lh-sm"
            onClick={onHide}
            disabled={loading}
          >
            Cancel <br /> (Recommended)
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm rounded-pill px-4 lh-sm"
            onClick={onConfirm}
            disabled={loading}
          >
            Yes, Delete <br />Permanently
          </button>
        </div>
      </div>
    </ModalCustom>
  );
};

DeleteUserConfirmationModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default DeleteUserConfirmationModal;
